import { render, staticRenderFns } from "./SurveyBBI.vue?vue&type=template&id=0e001073&scoped=true&"
import script from "./SurveyBBI.vue?vue&type=script&lang=js&"
export * from "./SurveyBBI.vue?vue&type=script&lang=js&"
import style0 from "./SurveyBBI.vue?vue&type=style&index=0&id=0e001073&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e001073",
  null
  
)

export default component.exports